import React, { useState } from 'react';
import '../../styles/general/typeEventCard.css'; // Archivo de estilos CSS
import { FaClock, FaMapMarkerAlt, FaSun, FaUser, FaLeaf, FaHome, FaGlassCheers } from 'react-icons/fa'; // Iconos de react-icons
import { MdCelebration } from 'react-icons/md';
import { BsFillGiftFill } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';

// Mapeo de iconos por tipo
const iconMap = {
  jardin: <FaLeaf className='icon-jardin general' />,
  infantil: <BsFillGiftFill className='icon-infantil general' />,
  salon: <FaGlassCheers className='icon-salon general' />,
  hacienda: <FaHome className='icon-hacienda general' />,
  terraza: <FaSun className='icon-terraza general' />,
};

// Función para formatear la URL a partir del nombre
const formatUrl = (name) => {
  if (typeof name === 'string') {
    return name
      .normalize("NFD")                      // Descompone letras con acentos
      .replace(/[\u0300-\u036f]/g, "")       // Elimina los acentos
      .trim() // Elimina espacios en blanco al principio y al final
      .toLowerCase() // Convierte a minúsculas
      .replace(/\s+/g, '-') // Reemplaza espacios con guiones
      .replace(/[^\w\-]+/g, ''); // Elimina caracteres no alfanuméricos y no guiones
  }
  console.warn('El parámetro `name` no es una cadena válida:', name); // Advertencia si `name` no es una cadena válida
  return ''; // Devuelve una cadena vacía si `name` no es una cadena
};

// Componente principal que renderiza las tarjetas
export const Cards = ({ items, itemType, mostImportantTypeEvents }) => {
  const location = useLocation(); // Obtiene la ubicación actual
  const currentUrl = location.pathname; // Ruta actual
  const [selectedId, setSelectedId] = useState(null); // Estado para almacenar el ID seleccionado
  const navigate = useNavigate(); // Hook para navegación

  // Maneja el clic en un enlace y navega a la página de detalle del lugar
  const handleLinkClick = (name, id, imagePrincipal) => {
    if (typeof name !== 'string' || !name.trim()) {
      console.warn('El nombre proporcionado no es válido:', name); // Advertencia si `name` no es válido
      return;
    }

    setSelectedId(id); // Guardar el ID en el estado
    console.log('Link ID seleccionado:', id); // Registro del ID seleccionado
    const formattedUrl = formatUrl(name); // Formatea el nombre para la URL
    console.log('url de link:', formattedUrl); // Registro del ID seleccionado
    navigate(`${currentUrl}/${formattedUrl}/${id}`, { state: { selectedId: id, imagePrincipal: imagePrincipal } }); // Navega a DetalleLugar con el ID
  };

  return (
    <section>
      <div className={`${itemType}-cards-container`}>
        {items.map((item) => (
          <div key={item.id} className={`${itemType}-card`}>
            {/* Imagen del ítem */}
              <img 
                src={item.imagePrincipal || 'default-image.png'} 
                alt={item.name} 
                className={`${itemType}-image`} 
                onClick={() => handleLinkClick(item.name, item.id, item.imagePrincipal)}
              />
            <div className={`${itemType}-info`}>
              {/* Nombre del ítem con icono */}
              <div onClick={() => handleLinkClick(item.name, item.id, item.imagePrincipal)}>
                <h2>
                  {iconMap[itemType] || <FaHome className='icon-hacienda general' />} {/* Usamos el mapeo directamente */}
                  {item.name || 'No disponible'}
                </h2>
              </div>
              <section className={`${itemType}-details`}>
                {/* Detalles del ítem */}
                <div className='detail-item'>
                  <div className='detail-container first'>
                    <div className='detail-info'>
                      <MdCelebration className='detail-icon celebration' />
                      <span>
                        {
                          // Accediendo directamente a `item.mostImportantTypeEvents`
                          (item.mostImportantTypeEvents && typeof item.mostImportantTypeEvents === 'string' 
                              ? item.mostImportantTypeEvents.split(',') 
                              : []
                          )
                          .filter(evento => evento.trim()) // Eliminar entradas vacías
                          .slice(0, 3) // Tomar solo los primeros tres
                          .join(', ') || 'No hay eventos disponibles'
                        }
                      </span>
                    </div>
                    <div className='detail-info'>
                      <a 
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.address)}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="maps-button"
                      >
                        <FaMapMarkerAlt className='detail-icon maps' />
                      </a>
                      <span className='truncate'>{item.address}</span>
                    </div>
                  </div>
                </div>              
                <div className='detail-container'>
                  <div className='detail-info'>
                    <FaUser className='detail-icon user' />
                    <span>Cap. máx: <span className='capacity'>{item.capacitymax || 'No disponible'}</span></span>
                  </div>
                  <div className='detail-info'> 
                    <FontAwesomeIcon className='icon-price detail-icon available' icon={faMoneyBill} color="green" />
                    <span>${item.priceInitial} - ${item.priceFinal || 'No disponible'}</span>
                  </div>
                  <div className='detail-info'>
                    <FaClock className='detail-icon available' />
                    <span className='time-event'>
                      {item.hours  ? item.hours  : 'No disponible'}
                    </span>
                  </div>
                </div>

              </section>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
